<div>
	<div class="tab-content">
		{{#if hasVideos}}
		<div role="tabpanel" class="tab-pane  {{videosActive}}" id="videos">
			<div class="row">
				{{#videos}}

				<div class="col-md-6 videos" >
					<iframe class="youtube" style="width: 90%" height="250px"  title="{{{label}}}" src="{{../protocol}}://www.youtube.com/embed/{{link}}?rel=0&autoplay=0" frameborder="0" allowfullscreen></iframe>
<!-- 					<div data-video_id="{{link}}" class="video-thumbs bg img-responsive" -->
<!-- 						style="background-image: url({{../protocol}}://img.youtube.com/vi/{{link}}/default.jpg);"> -->
<!-- 						<a class="thumb youtube_link" title="{{{label}}}" href="{{../protocol}}://www.youtube.com/watch?v={{link}}&rel=0&autoplay=0"> <img -->
<!-- 							data-video_id="{{link}}" style="width: 0px;" /> 0 size img in order this is compatible with the photos tab and with item_details.js <i -->
<!-- 							class="small fa fa-youtube-play" title="{{label}}"></i> -->
<!-- 						</a> -->
<!-- 					</div> -->
				</div>
				{{/videos}}
			</div>
		</div>
		{{/if}}
	</div>
</div>
